import styled from 'styled-components';

export const PageContentsStyle = styled.div`
  line-height: 1.6;
  p {
    padding: 12px 0;
  }

  ul {
    list-style: disc;
    margin-left: 32px;
    li {
      list-style: disc;
    }
  }

  ol {
    list-style: decimal;
    margin-left: 32px;
    li {
      list-style: decimal;
    }
  }
`;
